export default __webpack_public_path__ + "static/header-logo-92ec37d8c607c932a2750d033ebef87d.svg";